import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { TheSwingWidget, TheSwingWidgetProps } from './TheSwingWidget'

export const TheSwingWidgetRegistration = createRegisterableComponent(
    'election-swing-widget',
    (props: Omit<TheSwingWidgetProps, 'onEvent'>, { onEvent }) => {
        return <TheSwingWidget {...props} onEvent={onEvent} />
    },
)
